<template>
  <!-- DATE SLIDE ROW -->
  <div
    class="show-dates"
    :class="window.width < 767 ? '' : 'cinemas-show-dates'"
  >
    <div class="row">
      <div
        class="col-md-9 px-0 px-md-3"
        :class="window.width < 767 ? 'cinemas-show-dates' : ''"
      >
        <div class="pt-3 pl-3 showdate-listBox">
          <ul class="showdate-list">
            <li
              :key="dateListKey"
              v-for="(dateList, dateListKey) in dates"
              :class="checkDate(dateList) ? 'is-active' : ''"
              @click="$emit('onChangeDate', { event: $event, date: dateList })"
            >
              <div>
                <span class="month">{{ dateList | getFirstHalfOfMonth }}</span>
                <div class="date">{{ dateList | getDayDate }}</div>
                <span class="day">{{ dateList | getFirstHalfOfDay }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div
        class="col-md-3 align-self-center text-right select-show-type d-none d-md-block"
      >
        <div class="pr-3">
          <b-dropdown
            right
            :text="'Show Type: ' + filterShowsBy"
            class="border rounded"
            variant="none"
          >
            <b-dropdown-item
              v-for="(showTypes, showTypesKey) in availableShowTypes"
              :key="showTypesKey"
              >{{ showTypes }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div> -->
    </div>
    <!-- 
    <div
      class="col-12 d-md-none dark-border-bottom mx-auto my-3 pb-3 md-filter-drop"
    > -->
    <!-- {{opendDrop}} -->
    <!-- <b-dropdown
        :text="'Show Type: ' + filterShowsBy"
        class="border rounded"
        variant="none"
      >
        <b-dropdown-item
          v-for="(showTypes, showTypesKey) in availableShowTypes"
          :key="showTypesKey"
          >{{ showTypes }}</b-dropdown-item
        >
      </b-dropdown>
    </div> -->
  </div>
</template>

<script>
import SessionService from "@/apiServices/SessionService";
import moment from "moment";
export default {
  props: {
    // movie_code: { type: String },
    movie_date: { type: String },
    onChangeDate: {
      type: Function
    },
    dates: { type: Array }
  },
  data() {
    return {
      availableShowTypes: ["All", "2D", "3D", "4D", "4DX"],
      filterShowsBy: "All",
      // dates: [],
      shows: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  beforeMount() {
    // this.dateManager();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // dateManager() {
    //   // let todaysdate = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
    //   // let dates = Array(todaysdate);
    //   // for (let i = 1; i < 6; i++) {
    //   //   dates.push(
    //   //     moment(todaysdate)
    //   //       .add(i, "d")
    //   //       .format("YYYY-MM-DD HH:mm:ss.SSS")
    //   //   );
    //   // }
    //   // this.dates = dates;
    //   // console.log("this.dates :>> ", this.dates);
    // },
    checkDate(date) {
      return moment(moment(this.movie_date).format("YYYY-MM-DD")).isSame(
        moment(date).format("YYYY-MM-DD")
      );
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>

<style>
/* .cinemas-show-dates {
  border-radius: 5px;
  background-color: #000;
} */
.cinemas-show-dates {
  border-radius: 5px;
  background: var(--bg-dark-2);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}
.cinema-show-detail {
  padding: 25px 0px 25px 0px;
}

.section-cinemaDetails .col-12:not(:last-child) .cinema-show-detail {
  border-bottom: 1px solid var(--rose-gold);
}

.cinema-show-detail img {
  border-radius: 5px;
}

.cinema-show-title {
  font-size: 18px;
  margin-top: 5px;
  font-weight: 500;
  /* color: #494c62; */
}
/* .cinema-show-sm-content {
  background: var(--bg-dark-2);
} */

.cinema-show-detail .dot-list {
  font-size: 13px;
  color: #babbc3;
}

.showdate-listBox {
  overflow-x: auto;
  white-space: nowrap;
}
.select-show-type .dropdown-item.active,
.select-show-type .dropdown-item:active {
  color: var(--rose-gold);
  text-decoration: none;
  background-color: transparent;
}

.show-dates ::-webkit-scrollbar-track {
  box-shadow: none;
}
.show-dates ::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.show-dates ::-webkit-scrollbar-thumb {
  background-color: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/selectShowDate.vue